module.exports = __webpack_public_path__ + "img/47fabb8.svg";